<template>
  <div>
    <span class="editor-title">{{ title ? title : '' }}</span>
    <!-- <p v-if="type" class="editor-title ">{{ pageTitle ? pageTitle : '' }}</p> -->
    <div v-if="type==='00004'">
      <!-- 권한그룹(역할) 업무수행 절차 -->
      <v-row v-for="(procedure, index) in authList" :key="index" no-gutters>
        <v-col>
          <span class="editor-label">{{ index + 1 + '. ' + procedure.grpAuthNm }}</span>
          <v-textarea
            class="editor_bg"
            v-model="procedure.content"
            solo
            no-resize
            auto-grow
            spellcheck="false"
            hide-details="auto"
            :placeholder="`${procedure.grpAuthNm} 절차를 입력하세요`"
          />
        </v-col>
      </v-row>
    </div>
    <v-row v-else no-gutters>
      <v-col mols="12" class="mt-3" style="width:100%; border-radius: 8px;">
        <v-textarea
          class="full-heigh editor_bg"
          v-model="content"
          solo
          no-resize
          auto-grow
          row-height="100%"
          spellcheck="false"
          hide-details="auto"
          :readonly="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// Components
import baseview from '@/views/base/baseview.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardRight from '@/components/common/iCardRight.vue'

import { getCommonCode } from '@/api/common/commonApi'

import { getLeaderShipProcedure } from '@/api/procedure/leaderShipProcedure.js'
import { getRiskAssessmentProcedure } from '@/api/procedure/riskAssessmentProcedure.js'
import { getShBudgetProcedure } from '@/api/procedure/shBudgetProcedure.js'
import { getAuthGroupProcedure } from '@/api/procedure/authGroupProcedure.js'
import { getWorkerParticipationProcedure } from '@/api/procedure/workerParticipationProcedure.js'
import { getEmergencyActionPlanProcedure } from '@/api/procedure/emergencyActionPlanProcedure.js'
import { getContractServiceConsignmentProcedure } from '@/api/procedure/contractServiceConsignmentProcedure.js'
import { getPerformanceEvaluationProcedure } from '@/api/procedure/performanceEvaluationProcedure.js'
import { getEducationProcedure } from '@/api/procedure/educationProcedure.js'

export default {
  mixins: [baseview, iCardRight],
  components: {},
  props: {
    // type: {
    //   type: Boolean,
    //   default: false
    // },
    type: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      initCompId: '',
      title: '',
      tabList: [],
      content: '',
      authList: []
    }
  },
  computed: {},
  created() {
    this.initCompId = this.getCompId()
  },
  beforeMount() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
    Promise.all([getCommonCode('PRO001')]).then(response => {
      this.tabList = response[0].list
      this.btnSearch(true)
    })
  },
  mounted() {},
  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  methods: {
    async btnSearch(isNotify) {
      this.title = this.tabList.find(el => el.minorCd == this.type).minorNm
      const param = {
        clntId: this.getClntId()
      }
      switch (this.type) {
        case '00001':
          // 경영자 리더십 절차
          getLeaderShipProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00002':
          // 위험성평가 절차
          getRiskAssessmentProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00003':
          // 예산 편성 절차
          getShBudgetProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00004':
          // 권한그룹(역할) 업무수행 절차
          getAuthGroupProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00005':
          // 근로자 참여 절차
          getWorkerParticipationProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00006':
          // 비상대응계획 절차
          getEmergencyActionPlanProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00007':
          // 도급용역 위탁 안내 절차
          getContractServiceConsignmentProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00008':
          // 성과평가 절차
          getPerformanceEvaluationProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
        case '00009':
          // 안전보건 교육 절차
          getEducationProcedure(param, isNotify).then(response => {
            this.contentSetting(response)
          })
          break
      }
    },
    contentSetting(response) {
      if (this.type === '00004') {
        this.authList = response.list
        return
      }
      if (!response.success) {
        this.content = response.content
      } else {
        this.content = '절차서가 존재하지 않습니다.'
      }
    }
  }
}
</script>

<style lang="scss">
</style>
